import type { IconProps } from '../types';

const List = (props: IconProps) => (
  <svg
    fill="#7A7A98"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M4 7.54841C4 6.69325 4.63207 6 5.41176 6H26.5882C27.3679 6 28 6.69325 28 7.54841C28 8.40358 27.3679 9.09682 26.5882 9.09682H5.41176C4.63207 9.09682 4 8.40358 4 7.54841Z" />
    <path d="M4 16.2859C4 15.4307 4.63207 14.7375 5.41176 14.7375H26.5882C27.3679 14.7375 28 15.4307 28 16.2859C28 17.1411 27.3679 17.8343 26.5882 17.8343H5.41176C4.63207 17.8343 4 17.1411 4 16.2859Z" />
    <path d="M4 25.023C4 24.1678 4.63207 23.4745 5.41176 23.4745H26.5882C27.3679 23.4745 28 24.1678 28 25.023C28 25.8781 27.3679 26.5714 26.5882 26.5714H5.41176C4.63207 26.5714 4 25.8781 4 25.023Z" />
  </svg>
);

export default List;
